export const themeSwitcherStyle = {
  container: {
    width: 32,
    height: 32,
    padding: 8,
  },
};
